/**
 * Checks if the current page is active based on the provided page group
 * @param currentPage - The current page identifier
 * @param pageGroup - Object containing page identifiers to check against
 * @returns true if the current page is active, false otherwise
 */
export const isPageActive = (currentPage: string, pageGroup: Record<string, string>): boolean =>
  Object.values(pageGroup).includes(currentPage)
